export var HeaderSizes;
(function (HeaderSizes) {
    HeaderSizes["small"] = "small";
    HeaderSizes["medium"] = "medium";
    HeaderSizes["big"] = "big";
})(HeaderSizes || (HeaderSizes = {}));
